// Vendors
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { Box, Button, Toolbar } from '@mui/material';

// Components
import FormattedMessage from '../FormattedMessage';
import Loader from '@atoms/Loader';

// Assets
import logo from '@assets/images/logo.png';
import { useAppDispatch } from '@store/store';
import { resetInvoiceDetailsStart } from '@store/features/invoice/invoiceSlice';

const Component: React.FC = ({}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { oktaAuth } = useOktaAuth();
  const [loader, setLoader] = useState<boolean>(false);

  const handleLogout = async () => {
    setLoader(true);
    dispatch(resetInvoiceDetailsStart());
    localStorage.removeItem('okta-token-storage');
    localStorage.removeItem('groups');
    localStorage.clear();
    await oktaAuth.signOut();
    setLoader(false);
    void navigate('/login');
  };

  return (
    <Box className="header-container">
      <Loader display={loader} />
      <Toolbar className="tool-bar">
        <Box className="left-section">
          <img alt="Logo" src={logo} className="brand-logo" />
          <div className="divider"></div>
          <div className="brand-name">
            <span>
              <FormattedMessage id="APP.NAME" />
            </span>
          </div>
        </Box>
        <Box className="right-section">
          <Button className="logout-button" onClick={() => void handleLogout()}>
            <FormattedMessage id="BUTTON.LOGOUT" />
          </Button>
        </Box>
      </Toolbar>
    </Box>
  );
};

export default Component;
